import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import { CardsCarousel } from '@cotyorg/ccx-organism-carousel';
import { trackCarouselClickEvent } from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/carousel';

const RelatedProducts = ({ sectionHeadings }) => (
  <div className="related-products">
    <div className="grid-container">
      <div className="grid-x grid-padding-x">
        <div className="cell xsmall-16">
          <Heading level={2} extraClass="related-products__heading">
            {R.path(['relatedContentNew', 'heading'], sectionHeadings)}
          </Heading>

          <div className="grid-x">
            <div className="cell xsmall-14 xsmall-offset-1">
              <CardsCarousel
                cardsPerPageMap={{
                  xsmall: 2,
                  small: 2,
                  medium: 2,
                  large: 4,
                  xlarge: 4,
                }}
                cards={{
                  cardsStoreDataKey: 'relatedProducts',
                  isTitleUnderlined: false,
                  hasBackground: true,
                  isSmallTitle: true,
                  fullWidth: true,
                  headingLevel: 5,
                  showStarRating: false,
                  fixedHeight: true,
                  zoomOnHover: true,
                }}
                carousel={{
                  carouselsStoreDataKey: 'relatedProductsCarousel',
                  headingLevel: 5,
                  rightChevronIconSrc:
                    '/ccx-files/assets/carousel_nav_icon_right.svg',
                  leftChevronIconSrc:
                    '/ccx-files/assets/carousel_nav_icon_right.svg',
                  onIndexChange: ({ type, index, isForward }) =>
                    trackCarouselClickEvent({
                      page: 'product',
                      carousel: 'relatedProductsCarousel',
                      type,
                      index,
                      isForward,
                    }),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

RelatedProducts.propTypes = {
  sectionHeadings: PropTypes.shape({
    relatedContent: PropTypes.shape({
      heading: PropTypes.string,
    }),
  }).isRequired,
};

export default RelatedProducts;
